import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import React from "react";
import Typography from "@mui/material/Typography";
import { ParentRoleHierarchyOverview } from "../Models/ParentRoleHierarchyOverview";

const RoleCatalogueItem: React.FC<ParentRoleHierarchyOverview> = ({
  parentRoleName,
  privilegeNames,
  subRolePrivileges,
}) => {
  return (
    <Box
      sx={{
        paddingBottom: 1,
        paddingLeft: 2,
        paddingRight: 3,
        paddingTop: 1,
      }}
    >
      <Typography
        variant="h6"
        fontFamily="Lato"
        fontSize="16px"
        fontStyle="normal"
        fontWeight={600}
        lineHeight="normal"
      >
        {parentRoleName}
      </Typography>

      {subRolePrivileges && (
        <List>
          {subRolePrivileges.map((subRolePrivilege) => (
            <ListItem
              sx={{
                paddingLeft: "0px",
                alignItems: "start",
                display: "flex",
                justifyContent: "flex-start",
              }}
            >
              <List
                sx={{
                  width: "15%",
                }}
              >
                <ListItem
                  sx={{
                    paddingLeft: "0px",
                  }}
                >
                  <Box
                    sx={{
                      borderRadius: "20px",
                      backgroundColor: "rgba(0, 43, 107, 0.20)",
                      padding: "10px 20px",
                      width: "75%",
                    }}
                  >
                    <Typography
                      fontFamily="Lato"
                      fontSize="16px"
                      fontStyle="normal"
                      fontWeight={700}
                      lineHeight="normal"
                    >
                      {subRolePrivilege.subRoleName}
                    </Typography>
                  </Box>
                </ListItem>
              </List>
              <List
                sx={{
                  width: "25%",
                }}
              >
                {subRolePrivilege.privilegeNames.map((privilegeName) => (
                  <ListItem
                    sx={{
                      paddingBottom: "0px",
                    }}
                  >
                    <Box
                      sx={{
                        borderRadius: "20px",
                        backgroundColor: "#E3E1FF",
                        padding: "10px 20px",
                        width: "100%",
                      }}
                    >
                      <Typography
                        fontFamily="Lato"
                        fontSize="16px"
                        fontStyle="normal"
                        fontWeight={400}
                        lineHeight="normal"
                      >
                        {privilegeName}
                      </Typography>
                    </Box>
                  </ListItem>
                ))}
              </List>
            </ListItem>
          ))}
        </List>
      )}

      {privilegeNames.map((privilegeName) => (
        <ListItem
          sx={{ paddingLeft: "0px", paddingTop: "0px", paddingBottom: "0px" }}
        >
          <List
            sx={{
              paddingBottom: "0px",
              paddingLeft: "15%",
              width: "25%",
            }}
          >
            <ListItem
              sx={{
                paddingTop: "0px",
                paddingBottom: "0px",
              }}
            >
              <Box
                sx={{
                  borderRadius: "20px",
                  backgroundColor: "#E3E1FF",
                  padding: "10px 20px",
                  width: "100%",
                }}
              >
                <Typography
                  fontFamily="Lato"
                  fontSize="16px"
                  fontStyle="normal"
                  fontWeight={400}
                  lineHeight="normal"
                >
                  {privilegeName}
                </Typography>
              </Box>
            </ListItem>
          </List>
        </ListItem>
      ))}
    </Box>
  );
};

export default RoleCatalogueItem;
